// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/build/main." + {"139":"cd0460311ff1208dec55","435":"cd0460311ff1208dec55","639":"cd0460311ff1208dec55","818":"cd0460311ff1208dec55","962":"cd0460311ff1208dec55"}[chunkId] + ".min.css";
};